import { render } from "./message-tool.vue?vue&type=template&id=52c1d00e&scoped=true&ts=true"
import script from "./message-tool.vue?vue&type=script&lang=ts"
export * from "./message-tool.vue?vue&type=script&lang=ts"

import "./message-tool.vue?vue&type=style&index=0&id=52c1d00e&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52c1d00e"]])

export default __exports__